import axios from "axios";

const API = `${(process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "")}/api`;

let inflight = null;

/**
 * One in-flight /auth/me for the whole app. ThemeProvider and ProtectedRoute
 * both need the signed-in user on boot; two parallel calls doubled restore time.
 */
export function fetchAuthMe() {
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/auth/me`, { withCredentials: true })
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function resetAuthMeInflight() {
  inflight = null;
}
